import { render, staticRenderFns } from "./AddReceiver.vue?vue&type=template&id=b225e380&scoped=true"
import script from "./AddReceiver.vue?vue&type=script&lang=js"
export * from "./AddReceiver.vue?vue&type=script&lang=js"
import style0 from "./AddReceiver.vue?vue&type=style&index=0&id=b225e380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b225e380",
  null
  
)

export default component.exports